import { render, staticRenderFns } from "./AdminAccess.vue?vue&type=template&id=2362ee90&scoped=true&"
import script from "./AdminAccess.vue?vue&type=script&lang=js&"
export * from "./AdminAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362ee90",
  null
  
)

export default component.exports